var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.counterSoonShow)?_c('span',{staticClass:"badge badge-warning badge-pill my-pill"},[_vm._v("\n        "+_vm._s(_vm.values.soon)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.counterLateShow)?_c('span',{staticClass:"badge badge-danger badge-pill my-pill"},[_vm._v("\n        "+_vm._s(_vm.values.late)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }